<script>

    import { toast } from 'bulma-toast'
    import { AccountStore } from '../stores'

    import AccountsService from '../$services/accounts.service'
    import Button from '../$components/button.svelte'

    let loading = false
    let element = null

    async function getAccountShipmentsReport() {

        loading = true
        const blob = await AccountsService.getAccountShipmentsReport($AccountStore._id)
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar el reporte', type: 'is-danger'})

        element.download = `Reporte_envios.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<Button on:click={getAccountShipmentsReport} text="Envíos" icon="file-excel" fullwidth={true} {loading} />

<a href="/" bind:this={element} style="display: none;">*</a>